<p-dialog header="Provide additional feedback" class="header" [(visible)]="showdialog" [modal]="true"
    [style]="{ width: '35vw', minWidth: '350px' }" [draggable]="false" [resizable]="false" (onHide)="onClose()">

    <form [formGroup]="feedbackForm">
        <textarea rows="5" cols="30" pInputTextarea
            placeholder="{{ like ? 'What do you like about the response?' : 'What was the issue with the response? How could it be improved?' }}"
            formControlName="comment"></textarea>

        <div class="p-2">
            <label for="userRating" class="pr-2">Rate this Response: <span *ngIf="!like" class="text-red-900">*</span></label>
            <p-rating class="vertical-align-middle" id="userRating" formControlName="userRating" [cancel]="false"
                stars="5" />
        </div>


        <div class="button-container">
            <button label="Cancel" (click)="onClose()" class="p-button p-button-outlined-secondary mx-2">Cancel</button>
            <button [disabled]="!feedbackForm.valid" label="OK" (click)="emitSummary()" class="p-button p-button-primary submit-btn">Submit Feedback</button>
        </div>
    </form>
</p-dialog>